import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import capitalize from 'lodash/capitalize'
import Highlight from '@paintscout/ui/components/Highlight'
import Typography from '@paintscout/ui/components/Typography'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import ActivityContent from '../ActivityContent'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import ActivityOwner from '../ActivityOwner'
import QuoteLabel from '../QuoteLabel'
import ActivityDot from '../ActivityDot'

const useStyles = makeStyles<Theme, ActivityTypeComponentProps>((theme: Theme) => ({
  reason: {
    color: theme.palette.text.secondary
  }
}))

export default function QuoteStatusChangedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const classes = useStyles(props)

  let status = capitalize(activity.details.quote?.status ?? activity.details.invoice?.status)
  if (status === 'Onhold') {
    status = 'On Hold'
  }

  const reason = activity.details.events?.[0]

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        {showDocTypeDetails ? (
          status ? (
            <>
              <QuoteLabel activity={activity} /> status changed to <Highlight>{status}</Highlight>
            </>
          ) : (
            <>
              <QuoteLabel activity={activity} /> status changed
            </>
          )
        ) : status ? (
          <>
            Status changed to <Highlight>{status}</Highlight>
          </>
        ) : (
          <>Status changed</>
        )}
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {reason && !showDocTypeDetails && (
        <ActivityContent>
          <Typography variant="subtitle2" className={classes.reason}>
            {reason}
          </Typography>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
